/**
 * Drafting Center English Language Pack
 */
export default {
    draftingCenter: {
    // Time Formatting
        time: {
            justNow: 'Just now',
            minutesAgo: '{mins}m ago',
            hoursAgo: '{hours}h ago',
            yesterday: 'Yesterday',
            daysAgo: '{days}d ago',
        },

        // Navigation
        allDrafts: 'All Projects',
        loadMore: 'Load more',
        loadingMore: 'Loading...',
        recentDrafts: 'Recent Projects',
        recentDraftsTooltip: 'Showing up to 5 most recently updated drafts from the last 3 days',
        allProjects: 'All Projects',
        allProjectsRoot: 'All Projects (Root)',

        // Header Search and Actions
        searchPlaceholder: 'Search projects...',
        newFolder: 'New Folder',
        newProject: 'New Project',

        // Folder tree (left navigation)
        tree: {
            title: 'Folders',
            allProjects: 'All Folders',
            empty: 'No folders yet',
            expand: 'Expand',
            collapse: 'Collapse',
            newFolderHere: 'New folder here',
            newSubfolder: 'New subfolder',
        },

        // Home "select project/folder" dialog
        projectSelect: {
            trigger: 'Project',
            buttonDefault: 'Default Folder',
            tooltip: 'Select project or folder',
            title: 'Select Project or Folder',
            allProjects: 'All Projects',
            projects: 'Projects',
            selectFolderHint: 'Select a folder on the left to view projects',
            noProjects: 'No projects in this folder',
            confirm: 'Confirm',
            willUseDefault: 'Will be created in the default folder',
            willCreateIn: 'Will create a new project in "{name}"',
            willAppendTo: 'Will append to project "{name}"',
        },
        sortButton: 'Sort',
        total: 'Total',

        // Actions
        create: 'Create',
        edit: 'Edit',
        delete: 'Delete',
        move: 'Move',
        moveTo: 'Move to...',
        moveToFolder: 'Move to Folder',
        moveHere: 'Move Here',
        save: 'Save',
        cancel: 'Cancel',

        createProjectDialog: {
            projectName: 'Project name',
            projectNamePlaceholder: 'Optional, auto-generated if empty',
            docType: 'Type',
            techContent: 'Technical content',
            uploadFiles: 'Upload files',
            uploadFilesHint: 'PDF, Word, images supported, up to 5 files',
            addFile: 'Add file',
            submit: 'Start creating',
        },
        confirm: 'Confirm',
        createFolder: 'Create Folder',
        goBack: 'Go Back',
        enterFolder: 'Enter Folder',

        // Messages
        createSuccess: 'Created successfully',
        updateSuccess: 'Updated successfully',
        deleteSuccess: 'Deleted successfully',
        moveSuccess: 'Moved successfully',
        folderDeletedSuccess: 'Folder deleted successfully',
        projectDeletedSuccess: 'Project deleted successfully',
        deleteItemFailed: 'Failed to delete item',
        createFailed: 'Failed to create, please try again',
        updateFailed: 'Failed to update, please try again',
        deleteFailed: 'Failed to delete, please try again',
        moveFailed: 'Failed to move, please try again',
        fetchFailed: 'Failed to fetch data, please try again',

        // Project
        project: {
            name: 'Project Name',
            namePlaceholder: 'Enter project name',
            description: 'Description',
            descriptionPlaceholder: 'Add project description',
            updateSuccess: 'Project updated successfully',
            updateFailed: 'Failed to update project',
        },

        // Project Dialog
        projectDialog: {
            title: 'Edit Project Information',
            createTitle: 'New Project',
            projectType: 'Project Type',
            technicalField: 'Technical Field',
            technicalFieldOptions: {
                mechanical: 'Mechanical',
                electrical: 'Electrical',
                chemical: 'Chemical',
            },
            projectName: 'Project Name',
            projectNamePlaceholder: 'Enter project name (e.g., Patent Name - 202510087033.2)',
            optional: 'Optional',
            descriptionPlaceholder: 'Add detailed project description',
            clientTags: 'Client Tags',
            clientTagsDescription: 'Add client tags to organize and filter projects',
            clientTagsPlaceholder: 'Enter or select client name',
            save: 'Save',
        },

        // Folder
        folder: {
            create: 'Create Folder',
            createDesc: 'Organize and manage your projects',
            edit: 'Edit Folder',
            editDesc: 'Modify folder information',
            name: 'Folder Name',
            namePlaceholder: 'Enter folder name',
            description: 'Description',
            descriptionPlaceholder: 'Add folder description',
            optional: 'Optional',
            color: 'Color',
            colorTip: 'Choose a color to identify the folder',
            tags: 'Tags',
            tagsTip: 'Add client tags to the folder for easy filtering',
            loadFailed: 'Failed to load folder list',
            inputPlaceholder: 'Enter or select client',
        },

        // Filters
        filter: {
            keyword: 'Search Keywords',
            workType: 'Work Type',
            client: 'Client',
            status: 'Status',
            clearAll: 'Clear Filters',
        },

        // Work Type Filter
        workType: {
            all: 'All',
            drafting: 'Drafting',
            prosecution: 'OAR',
            disclosure: 'Disclosure',
            '00': 'Unspecified',
            '01': 'Patent Drafting',
            '10': 'Office Action Response',
            '11': 'Combined Project',
            '20': 'Disclosure',
        },

        // Views
        view: {
            grid: 'Grid',
            list: 'List',
            board: 'Board',
            gridView: 'Grid View',
            listView: 'List View',
        },

        // Sort
        sort: {
            name: 'Name',
            created: 'Created Time',
            updated: 'Updated Time',
            asc: 'Ascending',
            desc: 'Descending',
        },
        sortByUpdated: 'Sort by Update Time',
        sortByCreated: 'Sort by Creation Time',
        sortByNameAsc: 'Sort by Name (A-Z)',
        sortByNameDesc: 'Sort by Name (Z-A)',

        // Status
        status: {
            draft: 'Drafting',
            processing: 'Processing',
            completed: 'Completed',
            failed: 'Failed',
        },

        // Style Labels
        style: {
            standard: 'Standard',
            detailed: 'Detailed',
            concise: 'Concise',
        },

        // Dialogs
        dialog: {
            moreActions: 'More actions',
            deleteConfirm: 'Confirm Delete',
            deleteMessage: 'Are you sure you want to delete the selected items?',
            deleteMultipleWarning: 'You are about to delete <strong class="text-red-600 font-semibold">{count}</strong> items. This action cannot be undone.',
            cannotUndo: 'This action cannot be undone.',
            andMore: 'and {count} more...',
            deleting: 'Deleting...',
        },

        // Move to Folder Dialog
        moveDialog: {
            current: 'CURRENT',
            moveHereToThisLocation: 'Move here to this location',
            cannotMoveHere: 'Cannot move here',
            moveTo: 'Move to...',
            moveHere: 'Move Here',
            movingProject: 'Moving "{name}"',
            item: 'item',
            items: 'items',
            noSubfolders: 'No subfolders',
            noSubfoldersDesc: 'This folder doesn\'t contain any subfolders',
            instructions: 'Instructions',
            instructionsText: 'Click to select, double-click or use arrow to enter folder',
            selectedDestination: 'Selected Destination',
            goBack: 'Go back',
            enterFolder: 'Enter folder',
        },

        // Empty States
        empty: {
            noProjects: 'No projects yet',
            noResults: 'No matching projects',
            createFirst: 'Create your first project',
            noItemsFound: 'No items found',
        },

        // Count Formatting
        count: {
            project: 'no projects | {count} project | {count} projects',
        },

        // API Error Messages
        api: {
            fetchProjectsFailed: 'Failed to fetch projects',
            createProjectFailed: 'Failed to create project',
            fetchRecentProjectsFailed: 'Failed to fetch recent projects',
            deleteProjectsFailed: 'Failed to delete projects',
            updateProjectFailed: 'Failed to update project',
            updateMetadataFailed: 'Failed to update project metadata',
            moveProjectsFailed: 'Failed to move projects',
            fetchFoldersFailed: 'Failed to fetch folders',
            fetchAllFoldersFailed: 'Failed to fetch all folders',
            createFolderFailed: 'Failed to create folder',
            updateFolderFailed: 'Failed to update folder',
            deleteFoldersFailed: 'Failed to delete folders',
            moveFolderFailed: 'Failed to move folder',
            fetchStatsFailed: 'Failed to fetch statistics',
            fetchFiltersFailed: 'Failed to fetch filters',
        },

        // Folder operation messages
        folderCreateFailed: 'Failed to create folder',

        // Metadata operations
        metadata: {
            clickToCopyOaType: 'Click to copy OA type',
            clickToCopyOaNumber: 'Click to copy OA number',
            oaTypeCopied: 'OA type copied',
            oaNumberCopied: 'OA number copied',
            applicationNumberCopied: 'Application number copied',
            copyFailed: 'Copy failed',
        },

        // System folder
        systemFolder: {
            name: 'Default Folder',
            description: 'System',
            badge: 'System',
        },

        // Share
        share: 'Share',
        shareDialog: {
            title: 'Share Project',
            shareType: 'Share Type',
            public: 'Public',
            company: 'Company',
            personal: 'Personal',
            permission: 'Permission',
            readOnly: 'Read Only',
            canEdit: 'Can Edit',
            expiresAt: 'Expires At',
            expiresAtPlaceholder: 'Select expiration date (leave empty for never)',
            optional: 'Optional',
            selectUser: 'Select User',
            searchUserPlaceholder: 'Search by name or email...',
            shareLink: 'Share Link',
            copy: 'Copy',
            close: 'Close',
            createShare: 'Create Share',
            createSuccess: 'Share created successfully',
            createSuccessAndCopied: 'Share created successfully, link copied to clipboard',
            autoCopyFailed: 'Failed to copy link automatically, please copy manually',
            createFailed: 'Failed to create share',
            linkCopied: 'Link copied to clipboard',
            copyFailed: 'Copy failed',
            requireCompanyAccount: 'Requires company account',
            publicReadOnlyHint: 'Public shares can only be set to read-only',
            companyIdNotFound: 'Unable to retrieve company information, please contact administrator',
            selectUserRequired: 'Please select a user to share with',
            expiry7Days: '7 days',
            expiry15Days: '15 days',
            expiry30Days: '30 days',
            expiryNever: 'Never',
            noUsersFound: 'No users found',
            sharedTo: 'Shared To',
            copyLink: 'Copy link',
            publicHint: 'Anyone with the link can view this project',
            companyHint: 'Only members of your organization can access',
            personalHint: 'Only invited people can access',
        },
    },
};
